module.exports = __webpack_public_path__ + "img/logo.1976fb74.png";